import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom';
import Home from './pages/Home';
import Upload from './pages/Upload';
import Overall from './pages/Overall';
import MasterComparison from './pages/MasterComparison';
import Salary from './pages/Salary';
import Groups from './pages/Groups';
import Instructions from './pages/Instructions';
import Velmour from './pages/Velmour';
import Reports from './v2/Reports';
import V2Upload from './v2/Upload';
import V2Overall from './v2/Overall';
import V2Master from './v2/Master';
import V2Configs from './v2/Configs';
import './App.css';

function V1Layout({ apiKey, theme, toggleTheme, onLogout }: {
  apiKey: string;
  theme: 'light' | 'dark';
  toggleTheme: () => void;
  onLogout: () => void;
}) {
  return (
    <div className="App">
      <aside className="App-sidebar">
        <div className="sidebar-brand">
          <div className="brand-logo">X</div>
          <div className="brand-name">Xelence</div>
        </div>
        <nav className="sidebar-nav">
          <NavLink to="/" end>
            <span className="nav-icon">■</span>
            <span>Главная</span>
          </NavLink>
          <NavLink to="/overall">
            <span className="nav-icon">▦</span>
            <span>Сводный</span>
          </NavLink>
          <NavLink to="/master">
            <span className="nav-icon">≡</span>
            <span>Сравнение</span>
          </NavLink>
          <NavLink to="/salary">
            <span className="nav-icon">₸</span>
            <span>Зарплата</span>
          </NavLink>
          <NavLink to="/upload">
            <span className="nav-icon">↑</span>
            <span>Загрузка</span>
          </NavLink>
          <NavLink to="/groups">
            <span className="nav-icon">◈</span>
            <span>Группы</span>
          </NavLink>
          <NavLink to="/instructions">
            <span className="nav-icon">?</span>
            <span>Инструкция</span>
          </NavLink>
          <NavLink to="/velmour">
            <span className="nav-icon">♪</span>
            <span>Velmour</span>
          </NavLink>
          <NavLink to="/v2" style={{ marginTop: '0.75rem', borderTop: '1px solid var(--border)', paddingTop: '0.75rem' }}>
            <span className="nav-icon">↗</span>
            <span>New UI (v2)</span>
          </NavLink>
        </nav>
        <div className="sidebar-footer">
          <button className="theme-toggle" onClick={toggleTheme} title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}>
            {theme === 'light' ? '☾ Dark' : '☀ Light'}
          </button>
          <button className="logout-btn" onClick={onLogout}>Logout</button>
        </div>
      </aside>
      <main className="App-main">
        <div className="App-content">
          <Routes>
            <Route path="/" element={<Home apiKey={apiKey} />} />
            <Route path="/overall" element={<Overall apiKey={apiKey} />} />
            <Route path="/master" element={<MasterComparison apiKey={apiKey} />} />
            <Route path="/salary" element={<Salary apiKey={apiKey} />} />
            <Route path="/upload" element={<Upload apiKey={apiKey} />} />
            <Route path="/groups" element={<Groups apiKey={apiKey} />} />
            <Route path="/instructions" element={<Instructions />} />
            <Route path="/velmour" element={<Velmour />} />
          </Routes>
        </div>
      </main>
    </div>
  );
}

function App() {
  const [apiKey, setApiKey] = useState<string>(localStorage.getItem('apiKey') || '');
  const [keyInput, setKeyInput] = useState('');
  const [theme, setTheme] = useState<'light' | 'dark'>(
    (localStorage.getItem('theme') as 'light' | 'dark') || 'light'
  );

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => setTheme(theme === 'light' ? 'dark' : 'light');

  if (!apiKey) {
    return (
      <div className="App">
        <div className="auth-gate">
          <h2>Enter API Key</h2>
          <div className="auth-form">
            <input
              type="password"
              placeholder="API key"
              value={keyInput}
              onChange={(e) => setKeyInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && keyInput.trim()) {
                  localStorage.setItem('apiKey', keyInput.trim());
                  setApiKey(keyInput.trim());
                }
              }}
              autoFocus
            />
            <button
              onClick={() => {
                if (keyInput.trim()) {
                  localStorage.setItem('apiKey', keyInput.trim());
                  setApiKey(keyInput.trim());
                }
              }}
            >
              Enter
            </button>
          </div>
        </div>
      </div>
    );
  }

  const handleLogout = () => {
    localStorage.removeItem('apiKey');
    setApiKey('');
    setKeyInput('');
  };

  return (
    <BrowserRouter>
      <Routes>
        {/* v2 routes — render their own NavRail / shell */}
        <Route path="/v2" element={<Reports />} />
        <Route path="/v2/upload" element={<V2Upload />} />
        <Route path="/v2/overall" element={<V2Overall />} />
        <Route path="/v2/master" element={<V2Master />} />
        <Route path="/v2/configs" element={<V2Configs />} />

        {/* v1 — existing layout with sidebar */}
        <Route path="*" element={
          <V1Layout apiKey={apiKey} theme={theme} toggleTheme={toggleTheme} onLogout={handleLogout} />
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
